import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import WalletIcon from "@mui/icons-material/Wallet";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InsightsIcon from "@mui/icons-material/Insights";
import ScienceIcon from "@mui/icons-material/Science";
import CampaignIcon from "@mui/icons-material/Campaign";

// Only permissions for pages that are backed by real backend endpoints.
// The astrology/consultant-era permissions (CONSULTANT, LANGUAGE, SERVICE,
// EXPERTISE, BANK_ACCOUNTS, TRANSFER_FUNDS, SUB_ADMIN, …) were removed along
// with their dead routes.
export const validPermissions = [
  "DASHBOARD",
  "USER",
  "PLANS",
  "CREDENTIALS",
  "TEST_ACCOUNTS",
];

export const rawMenu = [
  {
    key: "/dashboard",
    name: "Dashboard",
    element: <DashboardIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/dashboard",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/user",
    name: "User",
    element: <PersonIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/user",
    style: { background: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/plan",
    name: "Plans",
    element: <WalletIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/plan",
    fontSize: "1rem",
  },
  {
    key: "/credentials",
    name: "Credentials",
    element: <SecurityIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/credentials",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  // Internal QA tooling. Last in the menu and visually distinct (amber icon) so
  // a destructive test action is not adjacent to normal admin work.
  {
    key: "/test_accounts",
    name: "Test Accounts",
    element: <ScienceIcon style={{ fontSize: "1.1rem", color: "#d97706" }} />,
    path: "/admin/test_accounts",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/campaigns",
    name: "Push Campaigns",
    element: <CampaignIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/campaigns",
    fontSize: "1rem",
    // Hidden from roles the route (and the backend admin group) would reject.
    roles: ["admin", "super_admin"],
  },
  {
    key: "/analytics",
    name: "Analytics",
    element: <InsightsIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/analytics/overview",
    fontSize: "1rem",
    // Rendered as a sub-menu by sidebar.jsx. `roles` (optional) hides a child
    // from roles the route itself would reject.
    children: [
      { key: "/analytics/overview", name: "Overview", path: "/admin/analytics/overview" },
      { key: "/analytics/screens", name: "Screens", path: "/admin/analytics/screens" },
      { key: "/analytics/elements", name: "Elements", path: "/admin/analytics/elements" },
      { key: "/analytics/flows", name: "Flows", path: "/admin/analytics/flows" },
      { key: "/analytics/paywall", name: "Paywall & Plans", path: "/admin/analytics/paywall" },
      { key: "/analytics/retention", name: "Retention", path: "/admin/analytics/retention" },
      {
        key: "/analytics/insight",
        name: "Insight",
        path: "/admin/analytics/insight",
        roles: ["admin", "super_admin"],
      },
      {
        key: "/analytics/acquisition",
        name: "Acquisition",
        path: "/admin/analytics/acquisition",
        roles: ["admin", "super_admin"],
      },
      {
        key: "/analytics/campaigns",
        name: "Campaigns & Ads",
        path: "/admin/analytics/campaigns",
        roles: ["admin", "super_admin"],
      },
      {
        key: "/analytics/economics",
        name: "Unit Economics",
        path: "/admin/analytics/economics",
        roles: ["admin", "super_admin"],
      },
      {
        key: "/analytics/data_quality",
        name: "Data Quality & Freshness",
        path: "/admin/analytics/data_quality",
      },
      {
        key: "/analytics/customer_360",
        name: "Customer 360",
        path: "/admin/analytics/customer_360",
        roles: ["admin", "super_admin"],
      },
    ],
  },
];

// Every surviving page is backed and safe to expose, and Premika is operated
// by a single super-admin. Rather than filter the menu by backend permission
// strings (which were astrology-era and unreliable — they could hide working
// pages), show all working pages. Per-route access is still role-protected via
// ProtectedRoute in Routes.js.
export const getPermissionObjects = (/* userPermissions */) => {
  const permittedMenu = rawMenu;
  const permittedPaths = permittedMenu.map((m) => m.path);
  const defaultRoute = permittedPaths[0] || "/admin/user";

  return { permittedMenu, permittedPaths, defaultRoute };
};
